export type ActionConstant = 'approval/fetchAsync';

export class ActionConstants {
    public static readonly fetch: string = 'approval/fetchAsync';
    public static readonly updateAllApprovalsFilterStatus: string = 'approval/updateAllApprovalsFilterStatus';
    public static readonly updateAllApprovalsPage: string = 'approval/updateAllApprovalsPage';
    public static readonly updateAllApprovalsFrom: string = 'approval/updateAllApprovalsFrom';
    public static readonly updateAllApprovalsTo: string = 'approval/updateAllApprovalsTo';
}
